// extracted by mini-css-extract-plugin
module.exports = {"featuresActionContainer":"style-module_featuresActionContainer__fI1E6IRQDpLJeWU0oGrG"};